import React, { ComponentProps } from 'react';
import { Select as AntSelect } from 'antd';
import { RefSelectProps } from 'antd/lib/select';
import { Dimension } from '@app/interfaces/interfaces';
export const { Option } = AntSelect;

import * as S from './BaseSelect.styles';

export interface BaseSelectProps extends ComponentProps<typeof AntSelect> {
  width?: Dimension;
  dropdownWidth?: string | number;
  multiLineOptions?: boolean;
  shadow?: boolean;
  className?: string;
}

export const BaseSelect = React.forwardRef<RefSelectProps, BaseSelectProps>(
  ({ className, width, dropdownWidth, multiLineOptions = true, shadow, children, ...props }, ref) => (
    <S.Select
      getPopupContainer={(triggerNode) => triggerNode}
      ref={ref}
      className={className}
      $width={width}
      $shadow={shadow}
      $multiLineOptions={multiLineOptions}
      popupMatchSelectWidth={dropdownWidth ? false : true}
      dropdownStyle={dropdownWidth ? { width: dropdownWidth } : undefined}
      {...props}
    >
      {children}
    </S.Select>
  ),
);
